<template>
  <div class="report-calendar">
    <div class="vx-card p-6">
      <label class="text-title">{{ isUpdateReportCalendar ? $t('exportFile.editReportCalendar') : $t('exportFile.autoReport') }}</label>
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-full mt-2 p-4">
          <div class="w-full p-4 pr-8" style="background: rgba(235, 235, 235, .25);height: 510px;">
            <!--            tên báo cáo-->
            <div class="name-report">
              <div class="vx-row">
                <label class=" text-cake ml-4">{{ $t('exportFile.nameReport') }} :</label>
                <p class="ml-2 text-font " style="color: rgba(var(--vs-danger), 1)">*</p>
              </div>
              <div class="">
                <vs-input
                  class="mt-2 w-full"
                  :placeholder="$t('exportFile.place')"
                  v-validate="{ required: true, regex: /^(?=.*?[a-z]).*$/ }"
                  data-vv-validate-on="blur|change|input"
                  type="text"
                  v-model="name"
                  name="name"
                ></vs-input>
                <span class="text-danger text-sm mt-1">
                      {{ errors.first("name") }}
                    </span>
              </div>
            </div>
            <!--            loại báo cáo-->
            <div class="type-report mt-6">
              <div class="vx-row">
                <label class=" text-cake ml-4">{{ $t('exportFile.typeReport') }} :</label>
                <p class="ml-2 text-font " style="color: rgba(var(--vs-danger), 1)">*</p>
              </div>
              <div class="select-type">
                <v-select
                  class=" mt-2 w-full"
                  icon="AlertCircleIcon"
                  name="typesReport"
                  data-vv-validate-on="input|blur"
                  v-validate="'required'"
                  :options="optionalType"
                  v-model="rangeTypeSelected"></v-select>
                <span class="text-danger text-sm mt-1">
                      {{ errors.first("typesReport") }}
                    </span>
              </div>
            </div>
            <!--            thời điểm-->
            <div class="time-report mt-6">
              <div class="vx-row">
                <label class=" text-cake ml-4">{{ $t('exportFile.time') }} :</label>
                <p class="ml-2 text-font " style="color: rgba(var(--vs-danger), 1)">*</p>
              </div>
              <div class="select-type">
                <datepicker name="time"
                            class="mt-2 w-full"
                            required
                            format='dd/MM/yyyy'
                            :placeholder="$t('realtimeChart.startDate')"
                            v-model="startDateReport"
                ></datepicker>
                <span class="text-danger text-sm mt-1">
                      {{ errors.first("time") }}
                    </span>
              </div>
              <div v-if="selectedDAY" >
                <v-select
                  class=" mt-2 w-full select"
                  v-model="selectSendDaily"
                  :options="optionsDay"
                >
<!--                  <option v-for="sendDaily in getTimeSendDaily(0,24)" :value="sendDaily">{{ sendDaily + " " }}-->
<!--                    {{ $t('exportFile.daily') }}-->
<!--                  </option>-->
                </v-select>
              </div>
              <div v-if="selectedWEEK" class="select-type">
                <v-select
                  class=" mt-2 w-full"
                  icon="AlertCircleIcon"
                  :options="optionalTime"
                  v-model="rangeTimeSelected"></v-select>
              </div>
            </div>
            <!--            thời điểm kết thúc-->
            <div class="time-report mt-6">
              <div class="vx-row">
                <label class=" text-cake ml-4">{{ $t('exportFile.endTimeReport') }}</label>
              </div>
              <div class="select-time">
                <datepicker name="time"
                            class="mt-2 w-full"
                            required
                            format='dd/MM/yyyy'
                            :placeholder="$t('realtimeChart.placeTime')"
                            v-model="endDateReport"
                ></datepicker>
              </div>
              <div class="mt-2">
                <vs-checkbox v-model="expirationNotice" @change="selectedCheckbox" class="text-checkbox m-2">
                  {{ $t('exportFile.sendEmailTime') }}
                </vs-checkbox>
              </div>
            </div>
            <div class="email-report mt-6">
              <div class="vx-row">
                <label class=" text-cake ml-4">Email</label>
              </div>
              <div class="w-full mt-4">
                <vs-checkbox class="text-checkbox m-2" v-model="sendNow" @change="sendEmails">
                  {{ $t('exportFile.sendToEmail') }}
                </vs-checkbox>
                <vs-checkbox class="text-checkbox m-2" v-model="fileAttached" @change="sendAttached">
                  {{ $t('exportFile.fileReport') }}
                </vs-checkbox>
              </div>
            </div>

          </div>
        </div>

        <div class="vx-col md:w-2/3 w-full mt-2 p-4">
          <div class="vx-row m-0">
            <label class="text-cake">{{ $t('exportFile.contentReport') }}</label>
            <feather-icon
              icon="HelpCircleIcon"
              class="ml-2 icon-help"
            >
            </feather-icon>
          </div>
          <div class="w-full p-4 pr-8 mt-2" style="background: rgba(235, 235, 235, .25)">
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full">
                <label class="text-cake">{{ $t('exportFile.topic') }}</label>
                <v-select
                  class="mt-2 w-full"
                  icon="AlertCircleIcon"
                  v-model="valueSelected"
                  :options="optionalTopics"
                  multiple>
                </v-select>
              </div>
            </div>
            <div class="vx-row mt-4">
              <div class="vx-col w-full">
                <div class="vx-row ml-1">
                <label class="text-cake">{{ $t('exportFile.dataRange') }}</label>
                <p class="ml-2 text-font " style="color: rgba(var(--vs-danger), 1)">*</p>
                </div>
              </div>
              <div class="vx-col md:w-1/2 mt-2 w-full">
                <datepicker name="dataRangeError"
                            class="mt-2 "
                            v-validate="'required'"
                            format='dd/MM/yyyy'
                            :placeholder="$t('realtimeChart.placeTime')"
                            v-model="startData"
                ></datepicker>
                <span class="text-danger text-sm mt-1">
                      {{ errors.first("dataRangeError") }}
                    </span>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col mt-4 md:w-1/2 w-full">
                <div class="vx-row">
                  <label class="ml-4 text-cake">{{ $t('exportFile.source') }}</label>
                </div>
                <v-select
                  class="mt-2 w-full"
                  icon="AlertCircleIcon"
                  type="number"
                  v-model.number="valueSelectedArticle"
                  :options="optionalArticle"
                  multiple>
                </v-select>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="vx-row ml-0 mt-4">
                  <label class="text-cake">{{ $t('exportFile.contentConfiguration') }}: </label>
                  <p class="ml-2 text-font " style="color: rgba(var(--vs-danger), 1)">*</p>
                </div>
              </div>
              <div class="vx-col mt-8 w-full">
                <div class="vx-row">
                  <div class="vx-col md:w-2/12 w-full">
                    <label class="ml-0 text-cake mt-2">{{ $t('exportFile.sendTo') }} :</label>
                  </div>
                  <div class="vx-col md:w-10/12 ti-input w-full">
<!--                    <vs-input v-model="emails" class="w-full"></vs-input>-->
                    <vue-tags-input
                      v-model="emails"
                      placeholder=""
                      :tags="tagsEmails"
                      :is-draggable="true"
                      @tags-changed="newTags => tagsEmails = newTags"
                      @tag-order-changed="newTags => tags = newTags"
                    />
                  </div>
                </div>
                <div class="vx-row mt-8">
                  <div class="vx-col md:w-2/12 w-full">
                    <label class="ml-0 text-cake mt-2">CC :</label>
                  </div>
                  <div class="vx-col md:w-10/12 ti-input w-full" v-for="(item,index) in ccEmails" :key="index">
                    <vue-tags-input
                      v-model="item.tag"
                      placeholder=""
                      :tags="item.action"
                      :is-draggable="true"
                      @tags-changed="newTags => item.action = newTags"
                      @tag-order-changed="newTags => item.action = newTags"
                    />
                  </div>
                </div>
              </div>
              <div class="vx-col w-full">
                <div class="vx-row mt-8">
                  <div class="vx-col md:w-2/12 w-full">
                    <div class="vx-row ml-0">
                      <label class="ml-0 text-cake mt-2">{{ $t('exportFile.title') }} :</label>
                      <p class="ml-2 text-font " style="color: rgba(var(--vs-danger), 1)">*</p>
                    </div>
                  </div>
                  <div class="vx-col md:w-10/12 w-full ti-input">
                    <vs-input name="title" v-validate="'required'" v-model="title" class="w-full"></vs-input>
                    <span class="text-danger text-sm mt-1">
                      {{ errors.first("title") }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-4 mb-4 flex flex-wrap items-center justify-end">
            <vs-button class="ml-auto mt-2 text-size" type="border" @click="$router.go(-1)">
              {{ $t('exportFile.cancel') }}
            </vs-button>
            <vs-button v-if="isUpdateReportCalendar" class="ml-4 mt-2 text-size" @click="updateReportCalendar">{{ $t('exportFile.update') }}
            </vs-button>
            <vs-button v-else class="ml-4 mt-2 text-size" @click="createReportCalendar">{{ $t('exportFile.createReportCalendar') }}
            </vs-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import DateRangePicker from '@/layouts/components/vue2-daterange-picker/components/DateRangePicker.vue'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import authConfig from '@/../auth_config.json';
import VueTagsInput from '@johmun/vue-tags-input';
import {quillEditor} from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import moment from "moment";
import Datepicker from 'vuejs-datepicker';
import TrialPopupVue from '../trial/TrialPopup.vue';

export default {
  components: {
    DateRangePicker,
    vSelect,
    VueTagsInput,
    quillEditor,
    Datepicker,

  },
  data() {
    return {
      tags : "gmail",
      defaultEmail: null,
      tagsEmails : [],
      tagsCcEmails: [],
      emailShow : null,
      isUpdateReportCalendar: false,
      expirationNotice: false,
      sendDaily: 0,
      startData: null,
      displayInput: true,
      selectedDAY: false,
      selectedWEEK: false,
      fileAttached: false,
      sendNow: false,
      time: null,
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: true,
        noCalendar: true
      },
      startDateReport: null,
      endDateReport: null,
      tagSendTos: [],
      tagCCs: [],
      title: null,
      name: null,
      emails:[],
      ccEmails:[{
        action:[]
      }],
      ccEmail : null,
      optionGroupTopics: [],
      valueSelected: [],
      originTopic: [],
      projectSelected: [],
      valueSelectedArticle: [],
      optionalTopics: [],
      optionsDay : [
        {label : 0 , value : 0}
      ],
      optionalArticle: [
        {label: this.$t('exportFile.postFb'), value: "104"},
        {label: this.$t('exportFile.commentFb'), value: "105"},
        {label: this.$t('exportFile.news'), value: "101"},
        {label: 'Youtube', value: "106"},
        {label: 'Forum', value: "111"},
        {label: 'Google', value: "113"},
        // {label: 'Tiktok', value: "116"},
        // {label: 'Tiktok Trending', value: "117"},
        {label: 'Twitter', value: "118"}
      ],
      optionalType: [
        {label: this.$t('exportFile.brandHealthByDay'), value: 'DAY'},
        {label: this.$t('exportFile.brandHealthByWeek'), value: 'WEEK'}
      ],
      optionalTime: [
        {label: this.$t('exportFile.monday'), value: 'Monday'},
        {label: this.$t('exportFile.tuesday'), value: 'Tuesday'},
        {label: this.$t('exportFile.wednesday'), value: 'Wednesday'},
        {label: this.$t('exportFile.thursday'), value: 'Thursday'},
        {label: this.$t('exportFile.friday'), value: 'Friday'},
        {label: this.$t('exportFile.saturday'), value: 'Saturday'},
        {label: this.$t('exportFile.sunday'), value: 'Sunday'},
      ],
      dateRange: {
        endDate: new Date(),
        startDate: (() => {
          let date = new Date();
          date.setDate(date.getDate() - 6);
          date.setHours(0, 0, 0);
          return date
        })()
      },
      valueOptionType: null,
      createBy: null,
      ccEm : null,
      organizationId: null,
      valueOptionTime: 'Monday',
      organizationName: null,
    }
  },
  computed: {
    topicSelected: {
      get() {
        let label = null;
        let object = this.optionalsTopic.find(el => el.value === this.topicName);
        if (!object) {
          return null

        }
        if (object && object.label.length > 13) {
          label = object.label.slice(0, 13) + '...';
        } else {
          label = object.label;
        }

        return {
          label: label,
          value: this.topicName,
          topicGroupId: this.topicGroupId
        }
      },
      set(object) {
        if (!object) {
          this.topicName = null;
        } else {
          this.topicName = object.value
        }
      }
    },
    rangeTypeSelected: {
      get() {
        let object = this.optionalType.find(el => this.valueOptionType === el.value);
        if (!object) {
          return null;
        }
        return {
          label: object.label,
          value: this.valueOptionType
        }
      },
      set(object) {
        this.valueOptionType = object ? object.value : null;
        if (object.value == 'DAY') {
          this.displayInput = false;
          this.selectedDAY = true;
          this.selectedWEEK = false;
        }
        if (object.value == 'WEEK') {
          this.displayInput = false;
          this.selectedDAY = true;
          this.selectedWEEK = true;
        }


      }
    },
    rangeTimeSelected: {
      get() {
        let object = this.optionalTime.find(el => this.valueOptionTime === el.value);
        if (!object) {
          return {};
        }
        return {
          label: object.label,
          value: this.valueOptionTime
        }
      },
      set(object) {
        this.valueOptionTime = object ? object.value : null;
      }
    },
    selectSendDaily: {
      get() {
        let object = this.optionsDay.find(el => this.sendDaily === el.value);
        if (!object) {
          return {};
        }
        return {
          label: object.label,
          value: this.sendDaily
        }
      },
      set(object) {
        this.sendDaily = object ? object.value : null;
      }
    }
  },
  methods: {
    async createReportCalendar(evt) {
      evt.preventDefault();
      let validate = await this.$validator.validateAll();
      if (!validate) {
        return this.$vs.notify({
          text: this.$t('warning.doNotFullInfomation'),
          icon: 'icon-alert-circle',
          iconPack: 'feather',
          color: 'danger'
        })
      }
      ;
      let result = this.valueSelected.map(el => el.value);
      if (result.length == 0) {
        result = Array.from(new Set(this.optionalTopics.slice(1).map(el => el.value)))
      }
      if (result[0].length) {
        result = [...result[0]];
      }
      let resultArticle = this.valueSelectedArticle.map(el => el.value);
      if (resultArticle.length == 0) {
        resultArticle = this.optionalArticle.map(item => item.value)
      }
      let userInfo = JSON.parse(localStorage.userInfo);
      this.organizationId = userInfo.organization.id;
      this.organizationName = userInfo.organization.organizationName;
      if (this.valueOptionType === null) {
        return this.$vs.notify({
          text: this.$t('exportFile.textReport'),
          icon: 'icon-alert',
          iconPack: 'feahter',
          color: 'danger'
        })
      }
      this.$vs.loading();
      if (this.dateRange) {
        let abc = this.ccEmails.map(cc => {
          let action = [];
          if (cc.action) {
            action = cc.action.map(action => {
              return action.text;
            }).filter(item => item);
            this.ccEmail = action
          }
          return {
            action : action
          }
        });
        let userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const payload = [{
          startDate: this.dateRange.endDate,
          endDate: this.endDateReport,
          startData: this.startData,
          dataTypes: [],
          reportTopicList: [
            {
              "topicGroupId": 0,
              "topicIds": result,
            }
          ],
          beanTypes: resultArticle,
          sendDaily: this.sendDaily,
          name: this.name,
          expirationNotice: this.expirationNotice,
          reportType: this.valueOptionType,
          organizationId: this.organizationId,
          organizationName: this.organizationName,
          emails: [
            this.emailShow
          ],
          ccEmails: this.ccEmail,
          title: this.title,
          nameDay: this.valueOptionTime,
          sendNow: this.sendNow,
          fileAttached: this.fileAttached,
          userId: 0,
          customerType: userInfo.customerType
        }];
        const path = '/report/create';
        this.$report
          .post(path, payload)
          .then(() => {
            this.$router.push('/user/v2/report-calendar-list').catch(() => {
            });
            this.$vs.loading.close();
            return this.$vs.notify({
              text: this.$t('exportFile.createSuccess'),
              iconPack: "feather",
              icon: "icon-alert",
              color: "primary"
            });
          }).catch(err => {
          this.$vs.loading.close();
          return this.$vs.notify({
            text:
              err.response.data.message ||
              err.response.data.error_description ||
              err.response.data.error,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
        });

      }
    },
    async updateReportCalendar(evt) {
      evt.preventDefault();
      let validate = await this.$validator.validateAll();
      if (!validate) {
        return this.$vs.notify({
          text: this.$t('warning.doNotFullInfomation'),
          icon: 'icon-alert-circle',
          iconPack: 'feather',
          color: 'danger'
        })
      }
      ;
      let result = this.valueSelected.map(el => el.value);
      if (result.length == 0) {
        result = Array.from(new Set(this.optionalTopics.slice(1).map(el => el.value)))
      }
      if (result[0].length) {
        result = [...result[0]];
      }
      let resultArticle = this.valueSelectedArticle.map(el => el.value);
      if (resultArticle.length == 0) {
        resultArticle = this.optionalArticle.map(item => item.value)
      }
      let userInfo = JSON.parse(localStorage.userInfo);
      this.organizationId = userInfo.organization.id;
      this.organizationName = userInfo.organization.organizationName;
      if (this.valueOptionType === null) {
        return this.$vs.notify({
          text: this.$t('exportFile.textReport'),
          icon: 'icon-alert',
          iconPack: 'feahter',
          color: 'danger'
        })
      }
      this.$vs.loading();
      if (this.dateRange) {
        let id = this.$route.query.id;
        let resultTopic = [{
          topicIds: result
        }]
        const payload = {
          beanTypes: this.beanTypes,
          ccEmails: this.ccEmails,
          emails: this.tagsEmails.map(el => el.text),
          startDate: this.startDateReport,
          endDate: this.endDateReport,
          expirationNotice: true,
          fileAttached: true,
          name: this.name,
          nameDay: this.valueOptionTime,
          reportType: this.valueOptionType,
          sendDaily: this.sendDaily,
          sendNow: true,
          startData: this.startData,
          statusReport: true,
          title: this.title,
          reportTopicList: resultTopic   
        }
        this.$report.post(`/report/update/${id}`, payload).then(() => {
            this.$router.push('/user/v2/report-calendar-list').catch(() => {
            });
            this.$vs.loading.close();
            return this.$vs.notify({
              text: this.isUpdateReportCalendar ? this.$t('exportFile.updateSuccess') : this.$t('exportFile.createSuccess'),
              iconPack: "feather",
              icon: "icon-alert",
              color: "primary"
            });
          }).catch(err => {
          this.$vs.loading.close();
          return this.$vs.notify({
            text:
              err.response.data.message ||
              err.response.data.error_description ||
              err.response.data.error,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
        });

      }
    },
    editReportCalendar : function () {
      this.filterReport().then(() => {
        let id = this.$route.query.id;
        if (id) {
          let dataResult = this.optionReportCalendar.find(el => el.id == id);
          let resultTagEmail = dataResult.emails.map(el => {
            return {
              text: el, 
              tiClasses: [ "ti-valid" ]
            }
          })
          
          this.tagsEmails = resultTagEmail;
          this.startDateReport = dataResult.startDate
          this.dateRange.startDate = dataResult.startDate
          this.endDateReport = dataResult.endDate
          this.startData = dataResult.startData
          this.valueOptionType = dataResult.reportType
          this.sendDaily = dataResult.sendDaily
          this.name = dataResult.name
          this.expirationNotice = dataResult.expirationNotice
          this.ccEmails = dataResult.ccEmails
          this.title = dataResult.title
          this.valueOptionTime = dataResult.nameDay
          this.sendNow = dataResult.sendNow
          this.fileAttached = dataResult.fileAttached
          this.isUpdateReportCalendar = true;
          if (this.valueOptionType == 'DAY') this.selectedDAY = true;
          if (this.valueOptionType == 'WEEK') this.selectedWEEK = true;
          let selected = [];
          this.optionalArticle.forEach(el => {
            if (dataResult.beanTypes.includes(el.value)) {
              selected.push(el);
            }
          })
          
          let selectedTopic = [];
          this.optionalTopics.forEach(el => {
            if (dataResult.reportTopicList[0].topicIds.includes(el.value)) {
              selectedTopic.push(el);
            }
          })
          this.valueSelectedArticle = selected;
          this.valueSelected = selectedTopic;
        }
      });

    },
    selectedCheckbox: function () {
      this.expirationNotice = !this.expirationNotice;
    },
    sendAttached: function () {
      this.fileAttached = !this.fileAttached
    },
    sendEmails: function () {
      this.sendNow = !this.sendNow
    },
    getTopics: function () {
      this.$business.post('topic/find-by-conditions', {}).then((response) => {
        this.optionalTopics = response.data.map(el => {
          return {
            label: el.topicName,
            value: el.id,
            groupId: el.topicGroupId,
            createBy: el.content
          }
        })
        this.optionalTopics.unshift({
          label: this.$t('articleBookmark.all'),
          value: this.optionalTopics.map(el => el.value),
          groupId: null
        })
      })
    },
    getTimeSendDaily: function () {
      // return new Array(stop - start).fill(start).map((n, i) => n + i);
      let time = [];
      for (let i = 0; i < 24 ; i++) {
          time.push({label : i + " " + "giờ hàng ngày" , value : i} )
      }
      this.optionsDay = time ;
    },

    getTopicGroups: function () {
      return new Promise((resolve, reject) => {
        this.$business.post('/topic-group/find-by-conditions', {}).then((res) => {
          this.optionGroupTopics = res.data;
          if (this.optionGroupTopics.length > 0) {
            this.optionGroupTopics = this.optionGroupTopics.map(el => {
              if (el.groupName && el.groupName.length > 25) {
                el.groupName = el.groupName.slice(0, 25) + '...';
              }
              return {
                label: el.groupName,
                value: el.id
              }
            })
            if (this.groupName) {
              let selectedItem = this.optionGroupTopics.find(item => item.value == this.groupName)
              if (selectedItem) this.optionGroupTopics = selectedItem;
            }
            this.optionGroupTopics.unshift({
              label: this.$t('articleBookmark.all'),
              value: this.optionalTopics.map(el => el.value),
              groupId: null
            })
          }
          resolve();
        }).catch(() => reject())
      })
    },
    getTopicByOrganizationBranding: function () {
      const result = this.optionGroupTopics;
      this.$vs.loading();
      const payload = {};
      this.$business
        .post(`topic/find-by-conditions`, payload)
        .then(res => {
          this.$business.post(`share-topic/get-all-share`, {}).then((response) => {
            let currentUserName = JSON.parse(localStorage.userInfo).email
            const dataShare = response.data;
            const dataShareTopic = response.data;
            if (dataShare.status == 0) {
              dataShareTopic.forEach(key => {
                key.status = dataShare.status;
              })
            }
            const data = [...res.data, ...dataShareTopic.filter(item => item.status == 0 || item.status == 1)];
            this.statusShare = response.data.status;
            if (res.status == "200") {
              this.countBranding = this.optionalBranding.length;
              this.countProductBranding = this.optionalProductBranding.length;
              this.countPersonalBranding = this.optionalPersonalBrandig.length;
              this.$vs.loading.close();
              this.responseData = data;
              data.forEach(el => {
                el.currentUserName = currentUserName;
                if (el.keywords.length > 2) {
                  el.plus = el.keywords.length - 2;
                  el.keyword = el.keywords.map(k => k.keyword).slice(0, 2).join(", ");
                } else {
                  el.keyword = el.keywords.map(k => k.keyword).join(", ");
                }
                if (el.topicName.length > 25) {
                  el.topicName = el.topicName.slice(0, 25) + '...';
                }
                el.createdDate = moment(el.createdDate || el.modifiedDate).format("DD/MM/YYYY");
                el.checked = false;
                if (!this.optionGroupTopics.find(item => item.value == el.topicGroupId)) {
                  el.isOther = true
                } else {
                  el.isOther = false
                }
              });
              this.topics = data;
              const countOther = data.filter(item => item.isOther);
              this.countOther = countOther.length;
            }
            let resultFilter = [];
            let checkedShareId = [];
            result.forEach(el => {
              resultFilter = data.filter(topic => el.value == topic.topicGroupId)
              checkedShareId = resultFilter.filter(filter => !filter.shareId);
              // let resultFilterOther = data.filter(topic => el.value != topic.topicGroupId)
              // let checkedShareOther = resultFilterOther.filter(filter => !filter.shareId);
              if (checkedShareId.length > 0) {
                el.checkedAll = true;
              }
              if (el.isOther) {
                this.checkedSelected = true;
              }
            })
          })
            .catch(() => {
              return this.$vs.loading.close();
            });
        })
    },
    findByGroup: function (e) {
      this.optionalsTopic = this.optionalsTopic.filter(el => el.topicGroupId == e.value);
    },
    updateI18n: function () {
      this.optionalType[0].label = this.$t('exportFile.brandHealthByDay')
      this.optionalType[1].label = this.$t('exportFile.brandHealthByWeek')
    },
    checkboxSource: function () {
      this.optionalTime[0].label = this.$t('exportFile.monday')
      this.optionalTime[1].label = this.$t('exportFile.tuesday')
      this.optionalTime[2].label = this.$t('exportFile.wednesday')
      this.optionalTime[3].label = this.$t('exportFile.thursday')
      this.optionalTime[4].label = this.$t('exportFile.friday')
      this.optionalTime[5].label = this.$t('exportFile.saturday')
      this.optionalTime[6].label = this.$t('exportFile.sunday')
    },
    saveByteArray: function (reportName, byte) {
      var blob = new Blob([byte], {type: "application/xml"});
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      var fileName = reportName;
      link.download = fileName;
      link.click();
    },
    initScreen() {
      this.getTopics();
      this.getTopicGroups().then(() => {
        this.getTopicByOrganizationBranding()
      })
      this.updateI18n();
      this.checkboxSource();
      this.filterReport();
    },
    filterReport() {
      return new Promise((resolve, reject) => {
        let userInfo = JSON.parse(localStorage.userInfo);
        this.emailShow = userInfo.email;
        // this.tagsEmails[0] = userInfo.email;
        this.organizationId = userInfo.organization.id;
        const payload = {
          defaultEmail: userInfo.email,
          organizationId: userInfo.organization.id
        }
        this.$report.post(`report/all`, payload).then((res) => {
          this.optionReportCalendar = res.data;
          this.optionReportCalendar = this.optionReportCalendar.map(el => {
            return {
              defaultEmail: el.email,
              name: el.name,
              organizationId: el.organizationId,
              reportType: el.reportType,
              sendDaily: el.sendDaily,
              nameDay: el.nameDay,
              emails: el.emails,
              ccEmails: el.ccEmails,
              title: el.title,
              organizationName: el.organizationName,
              expirationNotice: el.expirationNotice,
              startData: el.startData,
              reportTopicList: el.reportTopicList,
              userId: el.userId,
              sendNow: el.sendNow,
              fileAttached: el.fileAttached,
              dataTypes: el.dataTypes,
              beanTypes: el.beanTypes,
              endDate: el.endDate,
              statusReport: el.statusReport,
              id: el.id,
              startDate: el.startDate
            }
          })
          resolve();
        });
      })
    },
  },
  async created() {
    this.getTimeSendDaily();
    this.initScreen();
    this.editReportCalendar();
    this.$eventBus.$on('i18n', () => {
      this.initScreen();
    });
    let userInfo = JSON.parse(localStorage.userInfo);
    if (userInfo.email.includes("vnpost")) {
      this.optionalTime.push({label: this.$t('exportFile.brandHealthByVNPost'), value: 2})
    }
  }
}


</script>

<style scoped>
.text-title {
  font-size: 16px;
  letter-spacing: 0.44px;
  line-height: 24px;
  font-weight: bold;
  color: rgb(94 88 115);
}

.text-cake {
  font-size: 13px;
  letter-spacing: 0.2px;
  color: rgb(94 88 115);
  font-weight: bold;
}

.text-checkbox {
  font-size: 12px;
  line-height: 22px;
  color: rgb(159 162 180);
}
</style>
<style lang="css">
.vue-daterange-picker .ranges {
  float: right;
  border-left: 1px solid #ddd;
}

.daterangepicker {
  border-left: none !important;
}

.export-file {
  position: absolute;
  right: 2rem;
}

.reportrange-text {
  border-radius: 10px;
  height: 37px;
  line-height: 27px;
}

.title-size {
  font-size: 16px !important;
}

.text-size {
  font-size: 12px !important;
}

.minus-top {
  margin-top: -24px;
}

.selected-topic .vs__selected {
  color: #fff;
}

.selected-topic .v-select .vs__dropdown-toggle .vs__deselect svg {
  stroke: #fff;
  opacity: 1;
}

.ti-input {
  border-radius: 5px;
}

.icon-help {
  vertical-align: text-top;
  width: 14px;
  height: 15px;
  color: black;
}

/*.select {*/
/*  opacity: 0.6 !important;;*/
/*}*/
</style>
